var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.warnings),function(warning,index){return _c('Warning',{key:'warning' + index,staticClass:"mb-2",attrs:{"message":warning}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }